import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {withSnackbar} from "notistack";
import {Styles} from "../../../config/design/styles";
import {connect} from "trim-redux";
import {Link, withRouter} from "react-router-dom";
import { ReactReader , ReactReaderStyle} from './react-reader';
import SearchButton from "./components/SearchButton";
import TocListButton from "./components/TocListButton";
import axios from "axios";
import {defaultVariabls} from "../../../config";
import HighLighterButton from "./components/HighLighterButton";
import Brightness4RoundedIcon from '@material-ui/icons/Brightness4Rounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import FontSizeButton from "./components/FontSizeButton";
import Typography from "@material-ui/core/Typography/Typography";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import {Translate} from "../../../config/Translate";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import {ArrowBackRounded, SyncRounded} from "@material-ui/icons";
import Button from "@material-ui/core/Button/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import {truncate} from "../../../config/values";
import Hidden from "@material-ui/core/Hidden/Hidden";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import BooNameButton from "./components/BooNameButton";
function updateTheme(rendition, theme) {
    const themes = rendition.themes;
    switch (theme) {
        case 'dark': {
            themes.override('color', '#fff');
            themes.override('background', '#18202b');
            break;
        }
        case 'light': {
            themes.override('color', '#000');
            themes.override('background', '#fff');
            break;
        }
    }
}
class PlayerPage extends React.Component {
    constructor(props) {
        super(props)
        this.viewerRef = React.createRef()
        this.tocRef = React.createRef()
    }
    state = {
        location:!!this.props.book.location ? this.props.book.location : 0,
        current_chapter:null,
        theme:"light",
        current_page:"",
        percentage:0,
        rendition:undefined,
        search_result:[],
        search_query:"",
        selections:!!this.props.book.selections ? JSON.parse(this.props.book.selections): [],
        chapters:[],
        initial_rendition:false,
        i_color: null,
        font_size: "100%",
        selected_cfiRange: null,
        selected_contents: null,
        open_highlighter: false,
    };
    classes = this.props.classes;
    componentDidMount() {
        document.body.classList.add('no-chat');
        this.innitialRendition();
        setInterval(this.syncBook.bind(this), 30000);
    }

    componentDidUpdate(_, prevState) {
        if (this.state.rendition && (this.state.rendition !== prevState.rendition)) {
            this.setupRenditionListener();
        }
    }
    componentWillUnmount() {
        document.body.classList.remove('no-chat');
        this.syncBook();
        clearInterval(this.syncBook.bind(this));
        if (this.state.rendition) {
            try {
                /*this.state.rendition.off('selected', this.setRenderSelection);*/
            }catch (e) {
                console.log("error")
            }

        }
    }
    innitialRendition(){
        const { rendition,selections,initial_rendition } = this.state;
        if (rendition && !initial_rendition) {
            selections.map((item) => {
                rendition.annotations.add(
                    'highlight',
                    item.cfiRange,
                    {},
                    undefined,
                    'hl',
                    { fill: item.i_color, 'fill-opacity': '0.5', 'mix-blend-mode': 'multiply' }
                );
            })
            this.setState({
                initial_rendition:true
            })
        }
    }
    setRenderSelection(){
        const { rendition,i_color,selections,selected_cfiRange,selected_contents } = this.state;
        const newSelection = {
            text: rendition.getRange(selected_cfiRange).toString(),
            cfiRange:selected_cfiRange,
            i_color: i_color
        };
        this.setState({
            selections: [...selections, newSelection]
        });
        rendition.annotations.add(
            'highlight',
            selected_cfiRange,
            {},
            undefined,
            'hl',
            { fill: i_color, 'fill-opacity': '0.5', 'mix-blend-mode': 'multiply' }
        );
        const selection = selected_contents.window.getSelection();
        selection?.removeAllRanges();
        this.syncBook();
    }
    saveRenditionSelection(cfiRange, contents){
        this.setState({
            selected_cfiRange:cfiRange,
            selected_contents:contents
        })
        if(!!cfiRange){
            this.setState({
                open_highlighter:true
            })
        }
    }

    setupRenditionListener() {
        const { rendition,i_color } = this.state;
        if (rendition) {
            rendition.on('selected', this.saveRenditionSelection.bind(this));
        }
    }
    getRendition = async (_rendition) => {
        await updateTheme(_rendition, this.state.theme);
        await this.setState({
            rendition:_rendition
        })
        this.viewerRef.current = _rendition;
        await this.viewerRef.current.themes.fontSize(this.state.font_size);
        await this.viewerRef.current.themes.default({
            '@font-face' :{
                'font-family': 'Yekan',
                'src': 'url(../../IRANYekanXFaNum-Regular.woff2)'
            },
            '.contenttext' : {
                'line-height' : 1.4
            }
        })
        await this.viewerRef.current.themes.font("Yekan");

        await this.innitialRendition()
        await setTimeout(() => {
            this.state.rendition.views().forEach(view => view.pane ? view.pane.render() : null)
        }, 100);
    };
    locationChanged(epubcfi){
        let {chapters} = this.state;
        this.setState({location:epubcfi})
        if (this.state.rendition && chapters) {
            this.state.rendition.views().forEach(view => view.pane ? view.pane.render() : null)
            const { percentage,index, href } = this.state.rendition.currentLocation().start;
            const chapter = chapters.find((item) => item.href === href);
            let percentage_cal = (((percentage * 100) - 50) * 2) > 0 ? Math.round((((percentage * 100) - 50) * 2)) : 0
                this.setState({
                current_chapter: chapter,
                current_page: index,
                percentage:percentage_cal
            })
        }
    }

    async tocChanged(chapters){
        await this.setState({chapters})
    }
    handleSearch(q){
        let {location} = this.state;
        this.setState({
            search_query:q,
            location:0,
        })
        setTimeout(() => {
            this.setState({
                location
            })
        }, 1000);
    }
    handleSearchResult(result){
        result.then(
            (search_result) => this.setState({search_result})
        );

    }
    async handleRemoveSelection(selection){
        let {rendition,selections} = this.state;
        rendition?.annotations.remove(selection.cfiRange, 'highlight');
        await this.setState({
            selections: selections.filter((item) => item.cfiRange !== selection.cfiRange)
        });
        await this.syncBook();
    }
    handleShowSelection(selection){
        let {rendition} = this.state;
        rendition?.display(selection.cfiRange);
    }
    syncBook(){
        let {location,selections} = this.state;
        this.setState({
            syncing:true
        })
        let {book} = this.props;
        let data = new FormData();
        data.append('location', location);
        data.append('selections',  JSON.stringify(selections));
        data.append('book_id',  book.id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/ebook/sync`, data, config)
            .then(response => {
                this.setState({
                    syncing:false
                })
            })
            .catch(error => {
                console.log(error.response);
                this.props.history.push("/library")
                this.props.enqueueSnackbar(Translate.bookUsageExpired, {
                    variant: 'error',
                });
                this.setState({
                    syncing:false
                })
                return false
            });
    }
    async handleChangeColor(i_c){

        let {i_color} = this.state;
        /*if(!!i_color) await this.state.rendition.off('selected', this.setRenderSelection);*/
        await this.setState({
            i_color:i_c
        })
        if(!!i_c) await this.setRenderSelection();
        await this.setState({
            i_color:null,
            open_highlighter:false,
        })
    }

    async handleChangeFontSize(font_size){
        await this.setState({
            font_size
        })
        await this.viewerRef.current.themes.fontSize(this.state.font_size);
        await this.state.rendition.views().forEach(view => view.pane ? view.pane.render() : null)
    }
    toggleTheme(){
        let {theme,rendition} = this.state;
        this.setState({
            theme: theme === "dark" ? "light" : "dark"
        })
        updateTheme(rendition,theme === "dark" ? "light" : "dark")
    }
    render(){
        let {location,selections,rendition,syncing,current_page,percentage,theme,current_chapter,search_result,search_query,chapters} = this.state;
        let {url,title} = this.props;
        return (
            <>
                <div className="reader-header">
                    <Hidden smDown>
                        <Tooltip title={title}>
                            <h1>{truncate(title,25)}</h1>
                        </Tooltip>
                    </Hidden>

                    <a target="_blank" href={defaultVariabls.website}>
                        <img
                            className={"logo"}
                            src={`${defaultVariabls.website}/images/epanjere/panjere-logo.png`}
                            alt={Translate.appName}
                        />
                    </a>
                    <div className="actions">
                        <Hidden smUp>
                            <BooNameButton title={title}/>
                        </Hidden>
                        <HighLighterButton
                            handleColor={(i_color) => this.handleChangeColor(i_color)}
                            open_highlighter={this.state.open_highlighter}
                            closeHighlighter={() => this.setState({open_highlighter:false})}
                        />
                        <FontSizeButton
                            handleFont={(font_size) => this.handleChangeFontSize(font_size)}
                        />
                        <Tooltip arrow title={Translate.darkMode}>
                            <IconButton
                                onClick={() => this.toggleTheme()}
                                size="small"
                                className={this.state.theme === 'dark' ? "active"  : 'deactive'}
                            >
                                <Brightness4RoundedIcon/>
                            </IconButton>
                        </Tooltip>
                        <SearchButton
                            result={search_result}
                            handleSearch={(q) => this.handleSearch(q)}
                            handleClick={(location) => this.setState({location})}
                        />
                        <TocListButton
                            chapters={chapters}
                            current_chapter={current_chapter}
                            selections={selections}
                            handleClick={(location) => this.setState({location})}
                            handleShow={(selection) => this.handleShowSelection(selection)}
                            handleRemove={(selection) => this.handleRemoveSelection(selection)}
                        />
                        <Tooltip arrow title={Translate.backToLibrary}>
                            <IconButton
                                size="small"
                                component={Link}
                                to={'/library'}
                            >
                                <ArrowBackRounded/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
                <div className="react-reader-container">
                    <ReactReader
                        url={url}
                        location={location}
                        showToc={false}
                        query={search_query}
                        tocChanged={chapters => this.tocChanged(chapters)}
                        readerStyles={this.state.theme === 'dark' ? darkReaderTheme : lightReaderTheme}
                        locationChanged={(epubcfi) => this.locationChanged(epubcfi)}
                        getRendition={(_rendition) => this.getRendition(_rendition)}
                        handleSearchResult={(result) => this.handleSearchResult(result)}
                        loadingView={<AppCardLoaderFields/>}
                    />
                </div>
                <div className="reader-footer">
                    <Typography>{/*{!!current_chapter && current_chapter.label}*/} {!!current_page && current_page}</Typography>
                    <Button
                        onClick={() => this.syncBook()}
                        size="small"
                        startIcon={syncing ? <CircularProgress color="secondary" size={16}/> : <SyncRounded/>}
                    >
                        {Translate.sync}
                    </Button>
                </div>
                <LinearProgress color="secondary" variant="determinate" value={percentage} />

            </>
        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(PlayerPage))));

const lightReaderTheme = {
    ...ReactReaderStyle,
    readerArea: {
        ...ReactReaderStyle.readerArea,
        transition: undefined,
    },
};

const darkReaderTheme = {
    ...ReactReaderStyle,
    arrow: {
        ...ReactReaderStyle.arrow,
        color: 'white',
    },
    arrowHover: {
        ...ReactReaderStyle.arrowHover,
        color: '#ccc',
    },
    readerArea: {
        ...ReactReaderStyle.readerArea,
        backgroundColor: '#18202b',
        transition: undefined,
    },
    titleArea: {
        ...ReactReaderStyle.titleArea,
        color: '#ccc',
    },
};